import Badge from 'react-bootstrap/Badge';

import { IS_NATERA } from '@constants/constants';

type GuidanceType = 'dosingInformation' | 'alternateDrugAvailable' | 'otherPrescribingGuidance';

interface PGxGuidanceBadgeProps {
  guidanceType: GuidanceType;
}

const GUIDANCE_BADGES: Record<GuidanceType, { text: string; bg: string }> = {
  dosingInformation: { text: 'Dosing', bg: 'accent-blue-1-subtle' },
  alternateDrugAvailable: { text: 'Alt. Medication', bg: IS_NATERA ? 'secondary-subtle' : 'accent-teal-1-subtle' },
  otherPrescribingGuidance: { text: 'Other', bg: 'warning-subtle' },
};

export const PGxGuidanceBadge: React.FC<PGxGuidanceBadgeProps> = ({ guidanceType }) => {
  const { text, bg } = GUIDANCE_BADGES[guidanceType];

  return (
    <Badge bg={bg} text='black' className='guidance-badge'>
      {text}
    </Badge>
  );
};
